import useMode from '../../stores/mode';

function Index() {
    const mode = useMode();

    return (
        <button className="ARIndex" onClick={() => mode.set('index')}>
            Index
        </button>
    );
}

export default Index;
